import gql from 'graphql-tag';

export default gql`
  fragment mailCampaignContractFragment on MailCampaignContract {
    id
    mailCampaignSendsLimit
    mailCampaignSendsLimitProspect
    canSendNotOpenedCountsMore
    canSendBlastengine
    canSendBlastengineProspect
    linkBrandingDomain
    canUseLinkBranding
    linkBrandingProtocol
  }
`;
